import React from 'react'
import {connect} from 'react-redux'
import qs from 'query-string'

import tracker from '../../common/tracker'

import SignupPage from './SignupPage'
import SetPassPage from './SetPassPage'
import * as actions from '../actions'

class SignupSwitch extends React.Component {
  componentDidMount() {
    // the reason we are using query params is because there is only one /signup
    // URL and its component uses betaSubmitted and canRegister flags
    // to determine which page the user actually sees (ie signup or setpass)
    // b stands for beta_submitted where 1 is true
    let url_query = qs.parse(this.props.location.search)
    if(url_query.b === '1'){
      this.props.setBetaSubmitted(true)
    }
    tracker.signupLoaded()

    if (url_query.msg)
      this.props.setSignupStatus({status: url_query.status, msg: url_query.msg})
  }

  render() {
    if (this.props.betaSubmitted)
      return <SetPassPage {...this.props} />

    return <SignupPage {...this.props} />
  }
}

const mapStateToProps = state => ({
  betaSubmitted: state.auth.betaSubmitted
})

const SignupSwitchWrapper = connect(mapStateToProps, actions)(SignupSwitch)

export {SignupSwitchWrapper as default, SignupSwitch}



// WEBPACK FOOTER //
// ./assets/auth/components/SignupSwitch.js